import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';

function DeleteButton({ feedview, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(feedview.id)}
      body={`Are you sure you want to delete Feedview ${feedview.name}?`}
      confirmText="Confirm Delete"
      title={`Delete ${feedview.name}?`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  feedview: PropTypes.object,
  onDelete: PropTypes.func,
};

export default DeleteButton;
